import { render } from "./bankSetting.vue?vue&type=template&id=265cbea8"
import script from "./bankSetting.vue?vue&type=script&lang=js"
export * from "./bankSetting.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programming\\dashboard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__